import { Component, inject, signal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RDVClient, RDVClientInfoDto, RDVStatusMessage } from '@claas-rdv/rdv-client';

@Component({
  selector: 'app-display-view-component',
  imports: [RDVClient],
  templateUrl: './display-view-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-view-component.scss',
})
export class DisplayViewComponent {
  private route = inject(ActivatedRoute);
  accessToken: Signal<string>;
  showProtocol: Signal<boolean>;
  machine: string;
  autoConnect: boolean;

  readonly showFullscreenButton: boolean = typeof document !== 'undefined' && !!document.fullscreenEnabled;

  clientInfo: RDVClientInfoDto = {
                        screenResolution: {
                          width: 1024,
                          height: 768
                        }
                      };

  constructor() {
    this.accessToken = signal(this.route.snapshot.queryParamMap.get('jwt') ?? '');
    this.showProtocol = signal(this.parseBooleanParam(this.route.snapshot.queryParamMap.get('protocol'), false));
    this.machine = this.route.snapshot.queryParamMap.get('machine') ?? '';
    this.autoConnect = this.parseBooleanParam(this.route.snapshot.queryParamMap.get('autoConnect'), false);
    console.log("showProtocol: " + this.showProtocol);
    console.log("autoConnect: " + this.autoConnect);
  }

  onStatusChanged(_statusMessage: RDVStatusMessage): void {
  }

  private parseBooleanParam(value: string | null, defaultValue?: boolean): boolean {
    if (defaultValue === null || defaultValue === undefined) { defaultValue = false; }
    if (!value) return defaultValue;
    return value.toLowerCase() === 'true' || value === '1';
  }
}

